import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { CommonMethodService } from '../../common/commonMethod.service';
import { SelfCheckInService } from '../../services/selfCheckIn.service';
import { UserService } from '../../services/user.service';
import { AppUtility } from '../../common/apputility';

@Component({
  selector: 'app-add-self-check-in',
  templateUrl: 'addSelfCheckIn.component.html',
  providers: [CommonMethodService, SelfCheckInService, DatePipe, UserService]
})
export class AddSelfCheckInComponent implements OnInit, OnDestroy {

  visitorForm: FormGroup;
  subscribe: Array<Subscription> = [];
  deviceId: number;
  accountId: number;
  hostType: string;
  residentId: number;
  employeeId: number;
  isUniversal: boolean = false;
  hostPreset: boolean = false;
  selectedHostName: string = '';
  hostSearchTerm: string = '';
  hostSearchResults: Array<any> = [];
  showHostDropdown: boolean = false;
  countryList: Array<any> = [];
  todayDate1: Date;
  imageName: string = '';
  filestring: any;
  logo: Array<any> = [];
  loader: boolean = false;
  mode: string;

  constructor(
    private route: Router,
    private acticeRoute: ActivatedRoute,
    private selfCheckInService: SelfCheckInService,
    private toaster: ToastrService,
    private commonMethodService: CommonMethodService,
    public datepipe: DatePipe,
    private userService: UserService
  ) {
    this.acticeRoute.params.subscribe(params => {
      this.deviceId = params['deviceId'];
    });
  }

  ngOnInit(): void {
    this.todayDate1 = new Date();
    this.visitorForm = new FormGroup({
      fullName: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      documentType: new FormControl(''),
      documentId: new FormControl('', [Validators.maxLength(30)]),
      contactNo: new FormControl(''),
      dialingCode: new FormControl(''),
      email: new FormControl('', [Validators.maxLength(50)]),
      address: new FormControl('', [Validators.maxLength(100)]),
      nationality: new FormControl('', [Validators.required]),
      gender: new FormControl(''),
      mode: new FormControl(''),
      purposeOfVisit: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      expectedDate: new FormControl('', [Validators.required]),
      expectedVehicleNo: new FormControl('', [Validators.pattern('[a-zA-Z0-9 ]*'), Validators.maxLength(20)]),
      expectedVehicleModel: new FormControl('', [Validators.pattern('[a-zA-Z0-9 ]*'), Validators.maxLength(20)])
    });

    if (!this.deviceId) {
      this.loader = false;
      this.toaster.error('Invalid QR code', 'Error');
      return;
    }

    this.validateDevice();
    this.getCountryList();
  }

  validateDevice(): void {
    if (!this.deviceId) {
      this.loader = false;
      return;
    }
    this.loader = true;
    this.subscribe.push(this.selfCheckInService.validateDevice(this.deviceId.toString()).subscribe(
      data => {
        this.loader = false;
        const wrapper = JSON.parse(JSON.stringify(data));
        this.accountId = wrapper.accountId;
        if (wrapper.type === 'UNIVERSAL') {
          this.isUniversal = true;
          this.hostPreset = false;
        } else {
          this.isUniversal = false;
          this.hostPreset = true;
          this.hostType = wrapper.hostType;
          if (wrapper.residentId) {
            this.residentId = wrapper.residentId;
          }
          if (wrapper.employeeId) {
            this.employeeId = wrapper.employeeId;
          }
        }
      }, error => {
        this.loader = false;
        this.toaster.error(error.error.message, 'Error');
      }
    ));
  }

  getCountryList(): void {
    this.subscribe.push(this.userService.getCountryList('').subscribe(
      data => {
        this.countryList = data as any;
      },
      error => {
        console.log(error);
      }
    ));
  }

  onHostSearchChange(term: string): void {
    this.hostSearchTerm = term;
    this.residentId = null;
    this.employeeId = null;
    this.selectedHostName = '';
    if (!term || term.trim().length === 0 || !this.accountId) {
      this.hostSearchResults = [];
      this.showHostDropdown = false;
      return;
    }
    this.subscribe.push(this.selfCheckInService.searchHost(this.accountId, term).subscribe(
      data => {
        this.hostSearchResults = data as any;
        this.showHostDropdown = true;
      },
      error => {
        this.hostSearchResults = [];
        this.showHostDropdown = true;
        console.log(error);
      }
    ));
  }

  onHostFocus(): void {
    if (this.hostSearchTerm && this.hostSearchResults.length > 0) {
      this.showHostDropdown = true;
    }
  }

  onHostBlur(): void {
    setTimeout(() => {
      this.showHostDropdown = false;
    }, 200);
  }

  selectHost(host: any): void {
    this.selectedHostName = host.fullName;
    this.hostSearchTerm = host.fullName;
    this.hostType = host.hostType;
    if (host.hostType === 'RESIDENTIAL') {
      this.residentId = host.id;
      this.employeeId = null;
    } else {
      this.employeeId = host.id;
      this.residentId = null;
    }
    this.hostSearchResults = [];
    this.showHostDropdown = false;
  }
  onChangeMode(event: any): void {
    this.mode = event.target.value;
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const fextension = file.name.split('.');
      if (fextension.length < 2) {
        this.toaster.error('Please select valid file');
        return;
      }
      if (fextension[1] !== 'png' && fextension[1] !== 'jpg' && fextension[1] !== 'jpeg') {
        this.toaster.error('Image type should be .png or .jpg or .jpeg');
        return;
      }
      if (file.size > 1000000) {
        this.toaster.error('Image size should be less than 1 MB');
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.filestring = reader.result;
        this.imageName = this.filestring;
      };
    }
  }

  submitSelfCheckIn(): void {
    if (this.visitorForm.invalid) {
      this.toaster.error('Please fill all required fields', 'Error');
      return;
    }
    if (this.isUniversal && !this.residentId && !this.employeeId) {
      this.toaster.error('Please select a host', 'Error');
      return;
    }
    const details = Object.assign({}, this.visitorForm.value, {
      deviceId: this.deviceId,
      accountId: this.accountId,
      hostType: this.hostType,
      residentId: this.residentId,
      employeeId: this.employeeId
    });
    this.loader = true;
    this.subscribe.push(this.selfCheckInService.submitSelfCheckIn(details).subscribe(
      data => {
        this.loader = false;
        this.toaster.success('Check-in submitted successfully', 'Success');
        this.route.navigate(['/success', data.id]);
      },
      error => {
        this.loader = false;
        this.toaster.error(error.error.message, 'Error');
      }
    ));
  }
  ngOnDestroy(): void {
    if (this.subscribe) {
      this.subscribe.forEach(x => x.unsubscribe());
    }
  }
}




